export default "__VITE_ASSET__bHVLSdYx__"